module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/babel-runtime/core-js/symbol/iterator.js
// module id = 45
// module chunks = 0 1